<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="reviews">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <h1>Beoordelingen</h1>
        </div>
      <template slot="thead">
        <vs-th sort-key="name">Naam</vs-th>
        <vs-th v-if="staffRoute" sort-key="deliverer">Bezorger</vs-th>
        <vs-th sort-key="description">Beschrijving</vs-th>
        <vs-th sort-key="categories">Rating</vs-th>
        <vs-th v-if="staffRoute">Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="review-name" >{{tr.customer === null ? 'Anoniem' : (tr.customer.insertion !== null ? tr.customer.firstname + ' ' + tr.customer.insertion + ' ' + tr.customer.lastname : tr.customer.firstname + ' ' + tr.customer.lastname)}}</p>
            </vs-td>

            <vs-td v-if="staffRoute" >
              <p class="review-deliverer" >{{ tr.deliverer !== null ? tr.deliverer.firstname + " " + tr.deliverer.lastname : "" }}</p>
            </vs-td>

            <vs-td>
              <p class="review-note" v-html="tr.note"></p>
            </vs-td>

            <vs-td>
              <p class="order-category">
                <star-rating :rtl="$vs.rtl" :max-rating="5" :star-size="20" :inline="true" :rating="tr.service"></star-rating>
                <star-rating :rtl="$vs.rtl" :max-rating="5" :star-size="20" :inline="true" :rating="tr.quality"></star-rating>
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap" v-if="staffRoute">
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteReview(tr.id)" />
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>

import StarRating from 'vue-star-rating'

export default {
  components: {
    StarRating
  },
  data () {
    return {
      selected: [],
      reviews: [],
      itemsPerPage: 20,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      total: 0,
      activeOrder: null,
      popupActive: false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.reviews.length
    },
    staffRoute () {
      if(this.$route.meta.staff) {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
      } else {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
        return false
      }
    },
    activeProductTitle: function () {
      if (this.activeProduct !== null) {
        return 'Bestelnummer #' + this.activeProduct.id;
      }
    }
  },
  methods: {
    getReviews (e) {
      let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/' + this.$route.params.slug +'/reviews' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/reviews'
      if(e !== null && e !== undefined) {
        url += '?page=' + e
      }
      this.$http.get(url).then((response) => {
        this.reviews = response.data.data.reverse()
        console.log(this.reviews);
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      })
    },
    addNewData () {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
    },
    editData (data) {
        this.activeProduct = data
        this.popupActive = true
    },
    deleteReview(id) {
      let data = {
        _method: 'DELETE',
        id: id
      };
      this.$http
              .post("/v1/company/" + this.$route.params.slug + "/review/delete", data, {
                headers: {
                  Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                },
              })
              .then(() => {
                this.$util.notify('Gelukt', 'Review is verwijderd', this.$vs);
                this.getReviews();
                this.showPopup = false;
              })
              .catch((error) => {
                this.$util.logError(error, this.$vs);
              });
    },
    toggleDataSidebar (val = false) {
        this.addNewDataSidebar = val
    },
    getStatus(status) {
        if(status == 0) {
            return 'inactief';
        }
        if(status == 1) {
            return 'open';
        }
        if(status == 2) {
            return 'gesloten';
        }
        if(status == 3) {
            return 'Tijdelijk gesloten';
        }
        if(status == 4) {
            return 'Binnenkort geopend';
        }
    }
  },
  created () {

  },
  mounted () {
    this.isMounted = true
    this.getReviews();
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .order-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              width: 1rem;
              background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .order-img {
                max-height: 100px;
                max-width: 100px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
